import * as React from "react";
const SvgRemove = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 0 24 24", width: "24px", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" }), /* @__PURE__ */ React.createElement("path", { d: "M19 13H5v-2h14v2z" }));
export default SvgRemove;
